import { Item_Points } from "../../models/RestModels";

export function getEmptyItemPoints(): Item_Points
{
		return {
			id: 0,
			created: new Date(),
			updated: new Date(),
			created_by_user_id: 0,
			updated_by_user_id: 0,
			item_id: 0,
			type: 'AMOUNT',
			qty: 0
		};
}
